// Copyright (c) 2021 Deere & Company

export default Object.freeze({
    RESET_MASS_LABOR_RATE_REQUEST_FILTERS: 'RESET_MASS_LABOR_RATE_REQUEST_FILTERS',
    SET_LABOR_RATE_REQUESTS_DETAILS: 'SET_LABOR_RATE_REQUESTS_DETAILS',
    UPDATE_MASS_LABOR_RATE_REQUEST_FILTERED: 'UPDATE_MASS_LABOR_RATE_REQUEST_FILTERED',
    UPDATE_MASS_LABOR_RATE_REQUEST_FILTER_BY: 'UPDATE_MASS_LABOR_RATE_REQUEST_FILTER_BY',
    UPDATE_MASS_LABOR_RATE_REQUEST_SORT_BY: 'UPDATE_MASS_LABOR_RATE_REQUEST_SORT_BY',
    UPDATE_MASS_LABOR_RATE_REQUEST_SORT_DIRECTION: 'UPDATE_MASS_LABOR_RATE_REQUEST_SORT_DIRECTION'
});



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/actions-list.js